const exportToCsvData = (data: any[], header: string) => {
    return [header, ...data.map(row => Object.values(row).join(";"))].join("\n")
}

export const exportToCsvFile = (data: any[], header: string) => {
    return new Blob([exportToCsvData(data, header)], {type: 'text/csv;charset=utf-16'})
}
